import React, { useEffect, useState } from "react";
import InvestmentCommittee from "../InvestmentCommittee/InvestmentCommittee";
import InnovationMain from "../InnovationMain/InnovationMain";
import "./artParkDetails.css";
import Cohorts from "../Cohorts/Cohorts";
import client from "../../../utils/prismicHelpers";
import * as queries from "../../../utils/prismicQueries";
import InnoFellow from "../InnoFellow/InnoFellow";
import VentureFund from "../VentureFund/VentureFund";
import Emitter from '../../../utils/emitter';

const ArtParkDetails = () => {
  const [innoBg, setInnoBg] = useState(null);
  const [currentTab, setCurrentTab] = useState(null);
  const [updateProcess, setUpdateProcess] = useState(null);

  useEffect(() => {
    Emitter.on("MOVE_INNOVATION_SECTION", (newValue) => rebuilldTabs(newValue));
    let selected = sessionStorage.getItem("InnovationSection") || "View Programs";
    setCurrentTab(selected);
    client
      .query({
        query: queries.innovationBg,
      })
      .then((response) => {
        const innovationContent = response.data.allInnoprograms.edges[0].node;
        setInnoBg(innovationContent);
      })
      .catch((error) => {
        console.error(error);
      });
  });

  function rebuilldTabs(value) {
    setCurrentTab(value);
    // console.log("New tab set to :" + currentTab)

    const timer = setTimeout(() => {
      window.fullpage_api.reBuild();
    }, 500);

  }

  function rebuildFP(event) {
    let selected = event.target.innerHTML;

    switch (selected) {
      case "INNOVATION PROGRAM":
        sessionStorage.setItem("InnovationSection", "View Programs");
        break;
      case "INVESTMENT COMMITTEE":
        sessionStorage.setItem("InnovationSection", "Investment Committee");
        break;
      case "COHORTS":
        sessionStorage.setItem("InnovationSection", "Cohorts");
        break;
      case " INNOVATION FELLOW ":
        sessionStorage.setItem("InnovationSection", "Innovation Fellow");
        break;
      case " VENTURE FUND":
        sessionStorage.setItem("InnovationSection", "Venture Fund");
        break;
      default:
        break;
    }

    setCurrentTab(sessionStorage.getItem("InnovationSection") || "");
    //console.log(currentTab, "---");
    window.fullpage_api.reBuild();
  }

  return (
    <section
      style={{ backgroundImage: `url(${innoBg?.section_bg?.url})` }}
      className="innovation-container pattern"
    >
      {currentTab &&
        <div id="art-stepper" className="container  stepper">
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              className={
                `nav-link border-0 primary-text  ${currentTab === "View Programs"
                  ? "active" : ""}`}
              id="nav-home-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-home"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected="false"
              onClick={(e) => rebuildFP(e)}
            >
              STARTUP @ ARTPARK
            </button>
            <button
              className={
                `nav-link border-0 primary-text  ${currentTab === "Investment Committee"
                  ? "active"
                  : ""}`
              }

              id="nav-profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-profile"
              type="button"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="true"
              onClick={(e) => rebuildFP(e)}
            >
              INVESTMENT COMMITTEE
            </button>
            <button
              className={
                `nav-link border-0 primary-text  ${currentTab === "Cohorts"
                  ? "active"
                  : ""}`
              }

              id="nav-cohorts-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-cohorts"
              type="button"
              role="tab"
              aria-controls="nav-cohorts"
              aria-selected="false"
              onClick={(e) => rebuildFP(e)}
            >
              COHORTS
            </button>
            <button
              className={
                `nav-link border-0 primary-text  ${currentTab === "Innovation Fellow"
                  ? "active"
                  : ""}`
              }

              id="innovation-fellow-tab"
              data-bs-toggle="tab"
              data-bs-target="#innovation-fellow"
              type="button"
              role="tab"
              aria-controls="innovation-fellow"
              aria-selected="false"
              onClick={(e) => rebuildFP(e)}
            >
              {" "}
              INNOVATION FELLOW{" "}
            </button>
            <button
              className={
                `nav-link border-0 primary-text  ${currentTab === "Venture Fund"
                  ? "active"
                  : ""}`
              }

              id="venture-fund-tab"
              data-bs-toggle="tab"
              data-bs-target="#venture-fund"
              type="button"
              role="tab"
              aria-controls="venture-fund"
              aria-selected="false"
              onClick={(e) => rebuildFP(e)}
            >
              {" "}
              VENTURE FUND
            </button>
          </div>

          <div className="tab-content" id="nav-tabContent">
            <div
              className={`tab-pane fade
            ${currentTab === "View Programs" ? "show active" : ""}`}
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <InnovationMain></InnovationMain>
            </div>
            <div
              className={
                "tab-pane fade " +
                (currentTab === "Investment Committee" ? "show active" : "")
              }
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab"
            >
              <InvestmentCommittee></InvestmentCommittee>
            </div>
            <div
              className={
                "tab-pane fade " + (currentTab === "Cohorts" ? "show active" : "")
              }
              id="nav-cohorts"
              role="tabpanel"
              aria-labelledby="nav-cohorts-tab"
            >
              <Cohorts></Cohorts>
            </div>
            <div
              className={
                "tab-pane fade " +
                (currentTab === "Innovation Fellow" ? "show active" : "")
              }
              id="innovation-fellow"
              role="tabpanel"
              aria-labelledby="innovation-fellow-tab"
            >
              <InnoFellow></InnoFellow>
            </div>
            <div
              className={
                "tab-pane fade " +
                (currentTab === "Venture Fund" ? "show active" : "")
              }
              id="venture-fund"
              role="tabpanel"
              aria-labelledby="venture-fund-tab"
            >
              <VentureFund></VentureFund>
            </div>
          </div>
        </div>
      }
    </section>
  );
};

export default ArtParkDetails;
